import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

const Icon = styled(FontAwesomeIcon)`
  font-size: 18px;
  font-weight: 400;
`

export default Icon
